import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { TICKLER_REPORT_QUERY } from '../../../graphql.js'
import ReportGrid from '../ReportGrid'
import '../Custom.css'

const TICKLER_REPORT = gql(TICKLER_REPORT_QUERY)

export default function TicklerReport({ location }) {
  console.log('TicklerReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, TICKLER_REPORT, 'ticklerReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Tickler Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} />
          </tbody>
        </Table>
      </div>
    )
  }
}